import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { constant } from 'app/modules/common/helpers/constant';
import API from '../../../modules/common/services/api.config.json';

@Injectable()
export class AppointmentsService {

  appointmentServiceData = [];
  isLoading = false;

  constructor(private http: HttpClient) { }

  getAppointmentsServiceData(CitasDta): any {   
    this.isLoading = true;
    return new Promise((resolve, reject) => {
      this.http.post(constant.HOME_URL + API.MedicoView.getMedicoViewCitasData, CitasDta).subscribe(
        (data: any) => {
          if (data.code === 0) {
            this.appointmentServiceData = data.result;
            resolve(true);
          } else if (data.code === 1) {
            reject(true);
          }
          this.isLoading = false;
        },
        err => {
          console.error(err);
          this.isLoading = false;
        }
      );
    });
  }
}
